module.exports = __webpack_public_path__ + "img/nav_next.3e0d7559.png";